var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.343 1.342A6.667 6.667 0 1 1 8 1.333zM5.688 8.666c.075 1.3.37 2.443.787 3.278C6.982 12.96 7.56 13.333 8 13.333s1.018-.374 1.525-1.389c.418-.835.71-1.978.787-3.279zm-2.979 0a5.33 5.33 0 0 0 2.608 3.942l-.035-.067c-.52-1.042-.854-2.395-.931-3.875zm8.94-.001c-.078 1.48-.41 2.834-.931 3.876l-.036.067a5.33 5.33 0 0 0 2.608-3.943zM5.316 3.391A5.33 5.33 0 0 0 2.71 7.332h1.642c.077-1.48.41-2.831.931-3.873zM8 2.667c-.44 0-1.018.374-1.525 1.389-.418.834-.711 1.976-.787 3.276h4.624c-.077-1.3-.37-2.442-.787-3.276C9.018 3.04 8.44 2.667 8 2.667m2.718.792c.52 1.041.853 2.393.93 3.872h1.641a5.33 5.33 0 0 0-2.607-3.94q.017.034.036.068",
    clipRule: "evenodd"
  })));
};
export default SvgGlobe;